const assetUrl = (name) =>  "https://assets.aoshum.com/" + name;

export const storageAssets = {
    experience: assetUrl("Expereince.mp4"),
    graphics: assetUrl("Graphics2.mp4"),
    initialController: assetUrl("initialController.png"),
    problemOne: assetUrl("problemOne.png"),
    problemTwo: assetUrl("problemTwo.png"),
    iterationOne: assetUrl("iterationOne.png"),
    iterationTwo: assetUrl("iterationTwo.png"),
    additionalSpecs: assetUrl("additionalSpecs.png"),
    finalIteration: assetUrl("FinalIterationVid.gif"),
    cherub: assetUrl("Cherub.png"),
    sayso: assetUrl("Sayso.png"),
    heirarchyThree: assetUrl("HeirarchyThree.jpg"),
    readabilityThree: assetUrl("ReadabilityThree.mp4"),
    storytellingOne: assetUrl("StorytellingOne.mp4"),
    storytellingThree: assetUrl("Storytellingthree.mp4"),
    goalConcept: assetUrl("GoalConcept.mp4"),
    lineBacker: assetUrl("LBU.png"),
    gameplay: assetUrl("gameplay.png"),
    connectingProblem: assetUrl("connectingProblem.png"),
    connectingSolution: assetUrl("connectingSolution.png"),
    phoneOne: assetUrl("phoneOne.png"),
    phoneTwo: assetUrl("phoneTwo.png"),
    phoneThree: assetUrl("phoneThree.png"),
    mafiaVoting: assetUrl("mafiaVoting.png"),
    heaven: assetUrl("heaven.png"),
    automatedOne: assetUrl("automatedOne.png"),
    automatedTwo: assetUrl("automatedTwo.png"),
    automatedThree: assetUrl("automatedThree.png"),
    aiNotDesignedUI: assetUrl("AINotDesignedUI.png"),
    aiDesignedUI: assetUrl("AIDesignedUI.png"),
    backgroundTexture: assetUrl("Background Texture.png"),
    afterEffectsOne: assetUrl("afterEffectsOne.png"),
    afterEffectsTwo: assetUrl("afterEffectsTwo.png"),
    flame: assetUrl("Flame.mp4"),
    sunMoon: assetUrl("SunMoon.mp4"),
    connectingConsole: assetUrl("Conetcting to the Console.mp4"),
    disclosureConsole: assetUrl("Progressvie Disclosure.mp4"),
    multipleChoice: assetUrl("SaysoDemo.mp4"),
    moaOne: assetUrl("MoaOne.png"),
    moaTwo: assetUrl("Moa2.png"),
    moaThree: assetUrl("Moa3.png"),
    moaIntro: assetUrl("MoaIntro.png"),
    consoleIterationOne: assetUrl("Iteration 1.png"),
    consoleIterationTwo: assetUrl("Iteration 2.png"),
    consoleIterationThree: assetUrl("Iteration 3.png"),
    consoleIterationFinal: assetUrl("FinalPortal.png"),
    byuCollage: assetUrl("BYU Collage.mp4"),
    saysoFirst: assetUrl("SaysoFirst2.png"),
    saysoSecond: assetUrl("SaysoSecond.png"),
    saysoBrand: assetUrl("SaysoBrand.png"),
    adamPhoto: assetUrl("Adam Photo.jpg"),
    breezeEarlyTabbed: assetUrl("BreezeEarlyTabbed.png"),
    breezeBadBenefits: assetUrl("BreezeBadBenefits.png"),
    breezeFinalDashboard: assetUrl("BreezeFinalDashboard.png"),
    breezeMobileAnimation: assetUrl("BreezeMobileAnimation.mp4"),
    breezeEarlyDialOne: assetUrl("BreezeEarlyDialOne.png"),
    breezeEarlyDialTwo: assetUrl("BreezeEarlyDialTwo.png"),
    breezeFinalEarnTracker: assetUrl("BreezeFinalEarnTracker.mp4"),
    askElephantDesktopIntro: assetUrl("AskElephantDesktopIntro.png"),
    /* Project ten — AskElephant desktop (assets.aoshum.com) */
    projectTenTrayV1: assetUrl("EarlyTrayApp.png"),
    projectTenNotificationV2: assetUrl("NotificationApp.png"),
    projectTenOnboardingPermissionsEarly: assetUrl("DesktopOnboardingV1.png"),
    projectTenOnboardingPermissionsMid: assetUrl("DesktopOnboardingV2.png"),
    projectTenOnboardingIntermediaryFinal: assetUrl("DesktopFinalOnboarding.mp4"),
    projectTenTrayV2DynamicCta: assetUrl("DesktopDynamicCTA.mp4"),
    projectTenTrayV2MeetingsManage: assetUrl("DesktopRevertingDismissed.mp4"),
    projectTenTrayV2ReturnMeeting: assetUrl("DesktopReturning.mp4"),
    projectTenCrazyEights: assetUrl("Crazy Eights.png"),
    testerDarryl: assetUrl("Darryl.png"),
    testerDorothy: assetUrl("Dorothy.png"),
    testerLuna: assetUrl("Luna.png"),
    expertSusan: assetUrl("Susan.png"),
    expertRich: assetUrl("Richard.png"),
    expertDon: assetUrl("Don.png"),
}